import {Button, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {deletePropertyIssue, getPropertyIssue, resolveOrReopenIssue} from "../../service/PropertyService";
import {PropertyIssueView} from "./PropertyIssueView";
import IssueResolveForm from "./IssueResolveForm";

export function PropertyIssueModel({show, job, handleSave, handleClose, message, setMessage}) {
    const [propertyIssueData, setPropertyIssueData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [viewMode, setViewMode] = useState('list'); // list, add, resolve
    const [activeIssue, setActiveIssue] = useState(null);

    const refreshPropertyIssueData = () => {
        setIsLoading(true);
        getPropertyIssue(job.property_id).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setPropertyIssueData(data);
                });
            }
        }).finally(() => setIsLoading(false));
    };

    const actionReopenPropertyIssue = (updatedFormData) => {
        resolveOrReopenIssue(updatedFormData).then(response => {
            refreshPropertyIssueData();
        });
    };

    const actionDeletePropertyIssue = (issueId) => {
        deletePropertyIssue(issueId).then(response => {
            refreshPropertyIssueData();
        });
    };

    const actionResolvePropertyIssue = (issue) => {
        setActiveIssue(issue);
        setViewMode('resolve');
    }

    const fulfillResolve = (issue) => {
        resolveOrReopenIssue(issue).then(response => {
            refreshPropertyIssueData();
            setViewMode('list');
        });
    }

    useEffect(() => {
        refreshPropertyIssueData();
    }, [job]);

    const listMode = () => {
        return (propertyIssueData && propertyIssueData.length > 0 ? (propertyIssueData.map((propertyIssue, index) => (
            <PropertyIssueView
                key={index}
                issue={propertyIssue}
                actionDeletePropertyIssue={actionDeletePropertyIssue}
                actionReopenPropertyIssue={actionReopenPropertyIssue}
                actionResolvePropertyIssue={actionResolvePropertyIssue}
            />))) : (<div>There are no issues for this property. All good!</div>));
    }

    const addMode = () => {
        return (<div>Add Mode</div>)
    }
    const resolveMode = () => {
        return (<IssueResolveForm issue={activeIssue} activeJob={job} fulfillResolve={fulfillResolve}/>)
    }

    return (<Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width"
                   onClick={(e) => e.stopPropagation()}>
        <Modal.Header>
            <Modal.Title>Property Issues</Modal.Title>
            {/*<Button variant="primary" style={{marginLeft: 'auto'}}>Add New</Button>*/}

        </Modal.Header>
        <Modal.Body>
            {viewMode === 'list' && listMode()}
            {viewMode === 'add' && addMode()}
            {viewMode === 'resolve' && resolveMode()}


        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" disabled={isLoading} onClick={(e) => handleClose(e)}>
                Close
            </Button>
        </Modal.Footer>
    </Modal>);
}
